module.exports = {
      id: "ios-small-usage",
      viewBox: "0 0 448 512",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#ios-small",
      toString: function () {
        return this.url;
      }
    }